import moment from 'moment';

/** Shape emitted on socket `error-logs` / REST error-history rows. */
export interface ErrorHistoryEntry {
  id?: string | number;
  machineid?: string | number;
  errorid?: string | number;
  errorcode?: string | number;
  errorname?: string | null;
  errortype?: string | null;
  locationid?: string | number;
  machine_name?: string;
  siteid?: string | number;
  /** Canonical column from machineErrorLogs */
  DateTime?: string | Date | null;
  /** Alias added by BE for FE consumers */
  timestamp?: string | Date | null;
  [key: string]: unknown;
}

/** Resolve occurred-at from either DateTime (DB/API) or timestamp (alias). */
export function getErrorOccurredAt(entry: ErrorHistoryEntry): string | Date | null {
  const value = entry.DateTime ?? entry.timestamp ?? null;
  if (value === undefined || value === null || value === '') return null;
  return value;
}

export function formatErrorOccurredAt(
  entry: ErrorHistoryEntry,
  format = 'DD/MM/YYYY HH:mm:ss'
): string {
  const raw = getErrorOccurredAt(entry);
  if (!raw) return 'N/A';
  const m = moment(raw);
  return m.isValid() ? m.format(format) : 'N/A';
}

/** Prefer "code — name"; fall back to whichever fields exist. */
export function formatErrorCodeMessage(entry: ErrorHistoryEntry): string {
  const code = entry.errorcode != null && entry.errorcode !== '' ? String(entry.errorcode) : '';
  const name =
    entry.errorname != null && String(entry.errorname).trim() !== ''
      ? String(entry.errorname).trim()
      : '';

  if (code && name && name !== code) return `${code} — ${name}`;
  if (name) return name;
  if (code) return code;
  if (entry.errorid != null && entry.errorid !== '') return String(entry.errorid);
  return 'N/A';
}
